import { useActiveEntity } from '~/composables/useActiveEntity'

export const HREFLANG_MAP: Record<string, string> = {
  da: 'da',
  en: 'en',
  es: 'es',
  fr: 'fr',
  nn: 'no',
  se: 'sv'
}

export function useHreflang() {
  const activeEntity = useActiveEntity()
  const { sites } = useSite()
  const route = useRoute()

  const resolveLocale = () => {
    return Object.fromEntries(
      sites.value.map((l) => [
        l.siteId,
        { code: l.code, domain: l.domain }
      ])
    )
  }
  watch(
    () => [activeEntity.value, route.query.page],
    ([entity, pageValue]) => {
      if (!entity?.entity?.pathAlternatives?.length) return

      const currentPage = pageValue ?? '1'
      const localeMap = resolveLocale()

      const links = entity.entity.pathAlternatives.map((alt: any) => {
        const locale = localeMap[alt.siteId]
        if (!locale) return null

        const hreflang = HREFLANG_MAP[locale.code] ?? locale.code
        const suffix = currentPage !== '1' ? `?page=${currentPage}` : ''
        const basePath = alt.path === '/' ? '' : '/' + alt.path
        const alternativeLink =  `${useRequestURL().protocol}//${locale.domain}${basePath}${suffix}`
        activeEntity.value.links[locale.code] = alternativeLink
        return {
          rel: 'alternate',
          hreflang,
          key: `hreflang-${hreflang}`,
          href: alternativeLink,
        }
      }).filter(Boolean)


      if (activeEntity.value?.links?.hasOwnProperty('en')) {
        links.push({
          rel: 'alternate',
          hreflang: 'x-default',
          key: 'hreflang-x-default',
          href: activeEntity.value.links['en']
        })
      }


      useHead({ link: links })
    },
    { immediate: true }
  )
}
